import { SchedulablePresenter } from 'shared/presenters'
import { defined, definedNotNull } from 'shared/presenters/presenter'
import { ResourceRequirementQuantities } from 'shared/types'

export interface RentalRequirement {
  id: string
  count: number
  price: number
  name: string
}

interface FormatRequirements {
  desiredResourceRequirements: ResourceRequirementQuantities
  resourceRequirements?: SchedulablePresenter['resource_requirements']
}

const determineRequirement = ({
  resourceRequirements,
  id
}: {
  resourceRequirements: FormatRequirements['resourceRequirements']
  id: string
}) =>
  resourceRequirements?.find(
    resourceRequirement => resourceRequirement.id === id
  )

const formatRentalRequirements = ({
  desiredResourceRequirements,
  resourceRequirements
}: FormatRequirements): RentalRequirement[] => {
  if (!desiredResourceRequirements) return []

  return Object.entries(desiredResourceRequirements)
    .filter(([id]) => determineRequirement({ resourceRequirements, id }))
    .map(([id, count]) => {
      // Mark as defined because we are sure the filter removed any undefined value
      const requiretment = defined(
        determineRequirement({ resourceRequirements, id })
      )

      return {
        id: defined(requiretment.resource_type_id),
        count,
        price: definedNotNull(requiretment.price_pence),
        name: defined(requiretment.resource_type?.name)
      }
    })
}

export default formatRentalRequirements
